<template lang="pug">
  app-layout
    v-snackbar(v-model="showFailedRegistration" color="error")
      div {{ registrationMessage }}
    sole-prop-flow-modal
    v-flex(xs12)
      v-container.py-0.elevation-1.white(fluid)
      v-container(fluid grid-list-lg)
        v-layout(fill-height row-wrap)
          v-layout(wrap)
            v-flex(x12 ml-2)
              action-title-bar(title="standard brand and campaign registration" data-cy="title-bar")
            v-flex(xs12 ml-2)
              v-layout(v-if="isTrialSubscription" wrap)
                v-card.in-progress-card
                  v-card-text
                    span.font-weight-bold Unfortunately, you are in a trial and texting registration is only open to subscribers.
                    br
                    span To subscribe and unlock texting (as well as other great LionDesk features), click the button below to get started! 
                  v-card-actions
                    v-btn(color='primary' outline href=`${process.env.VUE_APP_ACCOUNTS_APP_URL}/settings`).text-none Start Your Subscription!
              v-layout(v-else-if="shouldDisplayForm" wrap)
                v-tabs(slider-color='primary')
                  v-tab Brand
                  v-tab Campaigns
                  v-tabs-items(v-model="tabSelected")
                    v-tab-item(:value='0')
                      v-card
                        v-card-text
                          form-brand(ref="formBrand" :standard="isStandardRegistration" :lock-text-vol="isStandardRegistration")
                    v-tab-item(:value='1')
                      v-card
                        v-card-text
                          form-campaign(:disable-submit="disableSubmitBtn" :validate-form-brand="validateFormBrand")
              v-layout(v-else wrap)
                v-card.in-progress-card
                  v-card-text
                    span.font-weight-bold(v-if="!isRegistrationCompleted") Your registration is in process.&nbsp;
                    span.font-weight-bold(v-else) Your registration is completed.&nbsp;
                    span(v-if="!isRegistrationCompleted") To review your registration status, please visit the Texting Console for details.
                    span(v-else) To review your registration, please visit the Texting Console.
                  v-card-actions
                    v-btn(color='primary' outline @click="goToTextConsole").text-none Open Texting Console
</template>
<script>
import FormBrand from './FormBrand'
import FormCampaign from './FormCampaign'
import ActionTitleBar from '@/Core/components/ActionTitleBar';
import { EventBus } from '@/event-bus';
import SolePropFlowModal from '@/Core/components/SolePropFlowModal';
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { REGISTRATION_STATES } from '@/Text/config/registrationStatus';
import { STANDARD_BRAND, LOW_STANDARD_BRAND } from 'lion-vue-src/config/brand';
import { STEPS_SOLE_PROPRIETOR, STANDARD_RETRY_STATES } from '../config';
import LdPlans from 'lion-vue-src/config/plans';

const solePropCloseAction = 'standard-form';

export default {
  name: 'RegisterCustomerA2P',
  components: {
    FormBrand,
    FormCampaign,
    ActionTitleBar,
    SolePropFlowModal,
  },
  props: {
    lowStandard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disableSubmitBtn: false,
    }
  },
  watch: {
    successRegistration: {
      handler(value) {
        if (!value) { return }
        this.disableSubmitBtn = true;
        this.modalSetStep(STEPS_SOLE_PROPRIETOR.PAYMENT);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        this.checkFor10dlcRegister();
      },
    },
    failedRegistration: {
      handler(value) {
        if (!value) { return }
        this.disableSubmitBtn = false;
        this.modalSetStep(STEPS_SOLE_PROPRIETOR.STATUS);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        this.checkFor10dlcRegister();
      },
    },
    addRegisterFeeAddonsSuccess: {
      handler(value) {
        if (!value) { return };
        this.modalSetStep(STEPS_SOLE_PROPRIETOR.STATUS);
        this.setShowRegistrationFlowModal({ bool: true, action: this.registrationModalClose });
        this.setAddRegisterFeeAddonsSuccess(false);
      },
    },
  },
  computed: {
    ...mapState({
      currentStep: state => state.registerCustomerA2p.currentStep,
      successRegistration: state => state.registerCustomerA2p.successRegistration,
      failedRegistration: state => state.registerCustomerA2p.failedRegistration,
      registrationMessage: state => state.registerCustomerA2p.registrationMessage,
      isPrefilledForm: state => state.registerCustomerA2p.preFilledForm,
      addRegisterFeeAddonsSuccess: state => state.payment.addRegisterFeeAddonsSuccess,
      registrationModalClose: state => state.registerSoleProprietorA2p.registrationModalClose,
      user: state => state.userInformation.user,
    }),
    ...mapState('conversations', [
      'has10dlcRegister',
      'registrationStatus10dlc',
      'registrationType10dlc',
    ]),
    isStandardRegistration() {
      if (this.isPrefilledForm) {
        return this.registrationType10dlc === STANDARD_BRAND;
      }

      return !this.lowStandard;
    },
    isRegistrationCompleted() {
      return this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_COMPLETED;
    },
    tabSelected: {
      get() {
        return this.currentStep;
      },
      set(value) {
        this.setStep({ step: value });
      }
    },
    showFailedRegistration: {
      get() {
        return this.failedRegistration;
      },
      set(value) {
        this.setFailedRegistration(value);
      },
    },
    shouldDisplayForm() {
      return !this.has10dlcRegister ||
        ((this.registrationType10dlc === STANDARD_BRAND || this.registrationType10dlc === LOW_STANDARD_BRAND) &&
          STANDARD_RETRY_STATES.includes(this.registrationStatus10dlc));
    },
    isTrialSubscription() {
      if (!this.user) { return false }
      const { txt_plan: userPlan } = this.user.subscriptionOverview;
      return userPlan.toLowerCase() == LdPlans.Trial.toLowerCase();
    }
  },
  methods: {
    ...mapMutations('registerCustomerA2p', [
      'setStep',
      'setSuccessRegistration',
      'setFailedRegistration',
    ]),
    ...mapActions('conversations', [
      'checkFor10dlcRegister',
    ]),
    ...mapActions('registerCustomerA2p', [
      'preFillForm'
    ]),
    ...mapActions('registerSoleProprietorA2p', {
      setShowRegistrationFlowModal: 'setShowRegistrationFlowModal',
      modalSetStep: 'setStep'
    }),
    ...mapActions('payment', ['setAddRegisterFeeAddonsSuccess']),
    validateFormBrand() {
      return this.$refs.formBrand.validateForm();
    },
    goToTextConsole() {
      this.$router.push('/communications/text/text-management');
    },
  },
  async mounted() {
    if (this.$route.hash === '#campaign') {
      this.setStep({ step: 1 });
    }
    await this.checkFor10dlcRegister();
    EventBus.$on('sole-prop-modal-close', data => {
      if (data === solePropCloseAction) {
        this.$router.back();
      }
    });
    if (this.isRegistrationCompleted) {
      return
    }
    this.preFillForm();
  },
}
</script>
<style scoped>
.title-a2p {
  font-size: 16px;
}

.in-progress-card {
  width: 100%;
}

.points {
  font-size: 16px;
  margin-top: -10px;
}
</style>
